import React from 'react';
import { Box, Typography, TextField, Grid } from '@mui/material';

const BudgetDetails = ({ form }) => {
    const {
        watch,
        setValue,
        formState: { errors },
    } = form;
    const formValues = watch();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 500 }}>
                Budget Details
            </Typography>

            <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                    <TextField
                        label="Lower Limit"
                        type="number"
                        placeholder="0"
                        value={formValues.budgetLowerLimit || ''}
                        onChange={(e) => setValue('budgetLowerLimit', +e.target.value, { shouldValidate: true })}
                        error={!!errors.budgetLowerLimit}
                        helperText={errors.budgetLowerLimit?.message}
                        size="small"
                        fullWidth
                        sx={{ width: '90%' }}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        label="Mid Limit"
                        type="number"
                        placeholder="0"
                        value={formValues.budgetMidLimit || ''}
                        onChange={(e) => setValue('budgetMidLimit', +e.target.value, { shouldValidate: true })}
                        error={!!errors.budgetMidLimit}
                        helperText={errors.budgetMidLimit?.message}
                        size="small"
                        fullWidth
                        sx={{ width: '90%' }}
                    />
                </Grid>

                <Grid item xs={12} md={4}>
                    <TextField
                        label="Higher Limit"
                        type="number"
                        placeholder="0"
                        value={formValues.budgetUpperLimit || ''}
                        onChange={(e) => setValue('budgetUpperLimit', +e.target.value, { shouldValidate: true })}
                        error={!!errors.budgetUpperLimit}
                        helperText={errors.budgetUpperLimit?.message}
                        size="small"
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default BudgetDetails;
